module.exports = __webpack_public_path__ + "img/4.55d040a2.png";